import { Injectable } from '@angular/core';
import {AppConfig} from '../app.config';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReminderService {
  private reminderListUrl = this.config.baseUrl + 'api/reminder';
  private reminderDetailUrl = this.config.baseUrl + 'api/reminder/:id';
  private storeReminderUrl = this.config.baseUrl + 'api/reminder';
  private deleteReminderUrl = this.config.baseUrl + 'api/reminder/';
  private updateReminderUrl = this.config.baseUrl + 'api/reminder/';
  private archiveReminderUrl = this.config.baseUrl + 'api/reminder/';
  public reminderEditId = Number(localStorage.getItem('reminderEditId'));
  public reminderArchiveId;
  constructor(private config: AppConfig,
              private http: HttpClient) { }
  reminderList(): Observable<any>{
    return this.http.get(this.reminderListUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  reminderDetail(id): Observable<any>{
    return this.http.get(this.reminderDetailUrl + id, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  storeReminder(reminder): Observable<any>{
    return this.http.post(this.storeReminderUrl, reminder, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans'),
        Accept: 'application/json'
      }
    }).pipe(map( (response: Response) => {
      return response;
    }));
  }
  deleteReminder(id): Observable<any>{
    return this.http.delete(this.deleteReminderUrl + id, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans'),
        Accept: 'application/json'
      }
    }).pipe(map( (response: Response) => {
      return response;
    }));
  }
  updateReminder(reminder): Observable<any>{
    this.reminderEditId = Number(localStorage.getItem('reminderEditId'));
    return this.http.put(this.updateReminderUrl + this.reminderEditId, reminder, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans'),
        Accept: 'application/json'
      }
    }).pipe(map( (response: Response) => {
      localStorage.removeItem('reminderEditId');
      return response;
    }));
  }
  archiveReminder(): Observable<any>{
    this.reminderArchiveId = Number(localStorage.getItem('reminderArchiveId'));
    return this.http.post(this.archiveReminderUrl + this.reminderArchiveId + '/archive', '',{
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans'),
        Accept: 'application/json'
      }
    }).pipe(map( (response: Response) => {
      return response;
    }));
  }
}
